<template>
  <div class="member-list-container">
    <van-nav-bar
      title="成员列表"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
      :title-style="{ color: '#333333', fontWeight: '600' }"
      :left-arrow-style="{ color: '#333333' }"
      :style="{ backgroundColor: '#FFD700' }"
    />
    
    <div class="search-section" v-if="!!selfInfo">
      <van-search class="search-bar" v-model="search" @search="onSearch" shape="round" show-action placeholder="输入用户ID">
        <template #action>
          <div @click="onSearch" class="search-btn">搜索</div>
        </template>
      </van-search>
      
      <div class="filter-section">
        <van-radio-group v-model="checked" class="id-type-group" direction="horizontal">
          <van-radio name="0" icon-size="14px">用户ID</van-radio>
          <van-radio name="1" icon-size="14px">上级ID</van-radio>
        </van-radio-group>
      </div>
    </div>
    
    <!--            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">-->
    <van-list 
      v-if="!!selfInfo" 
      class="member-list" 
      v-model:loading="loading" 
      :immediate-check="false"
      :finished="finished" 
      finished-text="没有更多了" 
      @load="onLoad"
      :offset="100"
    >
      <div class="member-card" v-for="(li, i) in list" :key="i">
        <div class="card-header">
          <div class="avatar-container">
            <img 
              :src="li.userInfo.portrait ? (config!=null ?config.fileServerUrl:'') + li.userInfo.portrait : muser" 
              alt="用户头像" 
              class="user-avatar"
            />
          </div>
          <div class="user-info">
            <h3 class="nickname">{{ li.userInfo.nickName }}</h3>
            <p class="join-time">加入时间：{{ getDisplayJoinTime(li.joinTime) }}</p>
          </div>
        </div>
        
        <div class="card-body">
          <div class="info-item" @click="onUidTapped(li)">
            <div class="info-label">用户ID</div>
            <div class="info-value">{{ li.userId }}</div>
          </div>
          <div class="info-item" @click="onInviteCodeTapped(li)">
            <div class="info-label">邀请码</div>
            <div class="info-value">{{ li.code }}</div>
          </div>
          <div class="info-item" @click="onParentIdTapped(li)">
            <div class="info-label">上级ID</div>
            <div class="info-value">{{ !!li.parentId ? li.parentId : '--' }}</div>
          </div>
        </div>
        
        <div class="card-footer">
          <div class="action-button left-button" @click="onCopyUserIdTapped(li)">
            <span class="icon">📋</span>
            复制用户ID
          </div>
          <div class="action-button right-button" @click="onIncomeTapped(li)">
            <span class="icon">📊</span>
            查看流水
          </div>
        </div>
      </div>
    </van-list>
    <!--            </van-pull-refresh>-->
    
    <van-popup v-model:show="confirm" :close-on-click-overlay="true" position="center">
      <div class="confirm-dialog">
        <div class="confirm-title">确认操作</div>
        <div class="confirm-content">是否确认{{ isEnable ? '启用' : '禁用' }}该用户？</div>
        <div class="confirm-buttons">
          <van-button type="default" plain size="small" @click="confirm = false" class="cancel-btn">取消</van-button>
          <van-button type="primary" round size="small" @click="onConfirmTapped" class="confirm-btn">确认</van-button>
        </div>
      </div>
    </van-popup>
    
    <Mask v-if="marke"></Mask>
  </div>
</template>
<script>
import muser from "@/assets/image/user.png";
// import { wxqq } from '../utils/utils'
import Mask from '../components/Mask'
import routerUtil from '../utils/routerUtil'
import { Toast } from "vant";
import copy from 'copy-to-clipboard';

export default {
  name: 'MemberList',
  data() {
    return {
      search: '',
      checked: '0',
      muser,
      selfInfo: null,
      groupInfo: null,
      searchType: 0,
      searchUid: null,
      loading: false,
      finished: false,
      refreshing: false,
      list: [],
      confirm: false,
      item: null,
      isEnable: false,
      marke: false,
    }
  },
  components: {
    Mask,
  },
  computed: {
    config: () => {
      return JSON.parse(localStorage.getItem("config"));
    },
  },
  mounted() {
    this.reqInfo()
    // this.marke = wxqq()
  },
  methods: {
    reqInfo() {
      Promise.all([this.$request.post('/api/user/mine/userInfo'), this.$request.postJson('/api/user/pay_group/info', {})])
        .then((values) => {
          if (values[0].data.code == 0 && values[1].data.code == 0) {
            this.selfInfo = values[0].data.data;
            this.groupInfo = values[1].data.data;
            if (!this.groupInfo) {
              Toast('暂无推广组信息');
              routerUtil.back()
              return;
            }
            this.getList()
          }
        });
    },
    getList(type) {
      let lastId = null
      if (type && this.list.length > 0) {
        lastId = this.list[this.list.length - 1].id
      }
      this.$request.postJson('/api/user/pay_group/member/list', {
        groupId: this.groupInfo.id,
        type: this.searchType,
        userId: this.searchUid == null ? 0 : this.searchUid,
        lastId: lastId,
        pageSize: 15
      }).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data.users.length == 0) {
            this.loading = false;
            this.refreshing = false
            this.finished = true;
            return
          }
          const uids = [];
          for (let user of res.data.data.users) {
            uids.push(user.userId);
          }
          this.$request.post('/api/user/info/userInfoByGroup', { userIds: JSON.stringify(uids) })
            .then((res1) => {
              this.loading = false
              this.refreshing = false
              if (res1.data.code == 0) {
                const userMap = new Map();
                for (let user of res1.data.data.users) {
                  if (user.code == 0) {
                    userMap.set(user.userId, user);
                  } else {
                    Toast("请求用户基本信息失败")
                    return;
                  }
                }
                for (let user of res.data.data.users) {
                  user.userInfo = userMap.get(user.userId);
                }
                this.list.push(...res.data.data.users)
                this.finished = res.data.data.users.length < 15
              }
            })
        }
      })
    },
    onClickLeft() {
      routerUtil.back()
    },
    onClickRight() {
    },
    onSearch() {
      if (this.search == "") {
        this.searchUid = null
      } else {
        if (isNaN(Number(this.search, 10))) {
          Toast("请输入用户ID")
          return
        }
        const uid = parseInt(this.search);
        this.searchUid = uid;
      }
      this.searchType = parseInt(this.checked)
      this.list = [];
      this.onRefresh()
    },
    onLoad() {
      this.getList(true)
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.getList()
    },
    onEnableTapped(li) {
      this.confirm = true;
      this.item = li;
      this.isEnable = true;
    },
    onDisableTapped(li) {
      this.confirm = true;
      this.item = li;
      this.isEnable = false;
    },
    onConfirmTapped() {
      this.confirm = false;
      const status = this.isEnable ? 0 : 1;
      this.$request.postJson('/api/user/pay_group/member/change_status', {
        groupId: this.groupInfo.id,
        userId: this.item.userId,
        status: status
      }).then((res) => {
        if (res.data.code == 0) {
          this.item.status = status
        }
      })
    },
    onUidTapped(li) {
      copy(li.userId);
      Toast('用户ID已复制');
    },
    onInviteCodeTapped(li) {
      copy(li.code);
      Toast('邀请码已复制');
    },
    onParentIdTapped(li) {
      if (!li.parentId) {
        return
      }
      copy(li.parentId);
      Toast('上级ID已复制');
    },
    onCopyUserIdTapped(li) {
      this.onUidTapped(li)
    },
    onIncomeTapped(li) {
      this.$router.push({
        name: 'Income',
        params: {
          userId: li.userId
        }
      });
    },
    getDisplayJoinTime(time) {
      const date = new Date(time);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const min = date.getMinutes();
      const sec = date.getSeconds();
      return `${date.getFullYear()}/${month > 9 ? month : '0' + month}/${day > 9 ? day : '0' + day} ${hour > 9 ? hour : '0' + hour}:${min > 9 ? min : '0' + min}:${sec > 9 ? sec : '0' + sec}`;
    }
  },
}
</script>
<style scoped lang="less">
/* 全局样式重置 */
* {
  box-sizing: border-box;
}

/* 主容器样式 */
.member-list-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #fafafa 0%, #ffffff 100%);
  font-family: 'PingFang SC', 'Helvetica Neue', Arial, sans-serif;
  color: #333333;
}

/* 搜索区域样式 */
.search-section {
  padding: 16px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin: 16px;
  border: 1px solid #e0e0e0;
}

.search-bar {
  margin-bottom: 16px;
  background: transparent;
  
  :deep(.van-search) {
    background-color: transparent !important;
  }
  
  :deep(.van-search__content) {
    background-color: #f5f5f5 !important;
    border: 1px solid #e0e0e0 !important;
    border-radius: 12px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
  }
  
  :deep(.van-search__content:focus-within) {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  
  :deep(.van-field__input) {
    color: #333333 !important;
    background: #f5f5f5 !important;
  }
  
  :deep(.van-field__placeholder) {
    color: #909090 !important;
  }
}

.search-btn {
  color: #333333;
  font-size: 14px;
  font-weight: 500;
}

.filter-section {
  margin-top: 12px;
}

.id-type-group {
  :deep(.van-radio__label) {
    font-size: 14px;
    color: #999999;
  }
  
  :deep(.van-radio__icon) {
    border-color: #e0e0e0;
  }
  
  :deep(.van-radio__icon--checked) {
    color: #333333;
  }
  
  :deep(.van-radio__icon--checked .van-icon) {
    background-color: #FFD700;
    border-color: #FFD700;
  }
}

/* 列表样式 */
.member-list {
  padding: 0 16px 80px;
  background-color: transparent;
}

/* 成员卡片样式 */
.member-card {
  margin: 0 16px 16px 16px;
  background-color: #ffffff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  overflow: hidden;
  position: relative;
  border: 1px solid #e0e0e0;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
    border-color: #cccccc;
  }
}

/* 卡片头部样式 */
.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
  color: #333333;
}

.avatar-container {
  margin-right: 16px;
}

.user-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #FFD700;
  background-color: #f5f5f5;
}

.user-info {
  flex: 1;
  color: #333333;
}

.nickname {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin: 0 0 6px 0;
}

.join-time {
  font-size: 14px;
  color: #666666;
  margin: 0;
}

/* 卡片主体信息样式 */
.card-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #333333;
  &:hover {
    background-color: rgba(255, 215, 0, 0.1);
    padding-left: 6px;
    border-radius: 4px;
  }
}

.info-label {
  font-size: 14px;
  color: #888888;
  font-weight: 500;
}

.info-value {
  font-size: 14px;
  color: #333333;
  font-family: 'Courier New', monospace;
  background-color: #e0e0e0;
  padding: 4px 10px;
  border-radius: 16px;
  border: 1px solid #cccccc;
  transition: all 0.2s ease;
  .info-item:hover & {
    background-color: #cccccc;
    border-color: #b0b0b0;
  }
}

/* 卡片底部操作区域样式 */
.card-footer {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.action-button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  gap: 6px;
}

.left-button {
  background-color: #e0e0e0;
  color: #333333;
  border: 1px solid #cccccc;
  &:hover {
    background-color: #cccccc;
    transform: translateY(-1px);
  }
}

.right-button {
  background-color: #cccccc;
  color: #333333;
  border: 1px solid #999999;
  &:hover {
    background-color: #999999;
    transform: translateY(-1px);
  }
}

.icon {
  font-size: 16px;
}

/* 确认对话框样式 */
.confirm-dialog {
  width: 300px;
  padding: 24px;
  background: white;
  border-radius: 16px;
  text-align: center;
}

.confirm-title {
  font-size: 18px;
  font-weight: 600;
  color: #FFD700;
  margin: 0 0 16px 0;
}

.confirm-content {
  font-size: 16px;
  color: #b8860b;
  margin-bottom: 24px;
  line-height: 1.5;
}

.confirm-buttons {
  display: flex;
  gap: 12px;
}

.cancel-btn, .confirm-btn {
  flex: 1;
  padding: 10px 0;
  font-size: 14px;
  font-weight: 500;
}

.cancel-btn {
  color: #FFD700;
  border-color: #FFD700;
}

.confirm-btn {
  background-color: #FFD700;
  color: #333333;
  border: none;
}

/* 自定义Vant组件样式 */
:deep(.van-radio__icon--checked .van-icon) {
  background-color: #FFD700;
  border-color: #FFD700;
}

:deep(.van-radio__label) {
  color: #999999;
}

:deep(.van-radio__input:checked + .van-radio__label) {
  color: #333333;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .member-card {
    padding: 16px;
    margin-top: 12px;
  }
  
  .search-section {
    padding: 12px;
  }
  
  .member-list {
    padding: 0 12px 60px;
  }
  
  .card-header {
    margin-bottom: 16px;
    padding-bottom: 12px;
  }
  
  .user-avatar {
    width: 50px;
    height: 50px;
  }
  
  .nickname {
    font-size: 16px;
  }
  
  .confirm-dialog {
    width: 280px;
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .card-body {
    gap: 12px;
  }
  
  .action-button {
    padding: 10px;
    font-size: 13px;
  }
  
  .info-value {
    font-size: 13px;
    padding: 3px 8px;
  }
}
</style>
